const ImageScale = [
  {
    title: '16:9',
    ratio: 9 / 16,
    checked: true,
  },
  {
    title: '2:1',
    ratio: 1 / 2,
    checked: false,
  },
  {
    title: '1.85:1',
    ratio: 1 / 1.85,
    checked: false,
  },
  {
    title: '2.35:1',
    ratio: 1 / 2.35,
    checked: false,
  },
  {
    title: '2.39:1',
    ratio: 1 / 2.39,
    checked: false,
  },
  {
    title: '1.66:1',
    ratio: 1 / 1.66,
    checked: false,
  },
  {
    title: '4:3',
    ratio: 3 / 4,
    checked: false,
  },
  {
    title: '1:1',
    ratio: 1,
    checked: false,
  },
  {
    title: '9:16',
    ratio: 16 / 9,
    checked: false,
  },
  {
    title: '1:2',
    ratio: 2 / 1,
    checked: false,
  },
  {
    title: '3:4',
    ratio: 4 / 3,
    checked: false,
  },
]

export default ImageScale
